import { render, staticRenderFns } from "./ContactUsH5.vue?vue&type=template&id=1901f928&scoped=true&"
import script from "./ContactUsH5.vue?vue&type=script&lang=js&"
export * from "./ContactUsH5.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsH5.vue?vue&type=style&index=0&id=1901f928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1901f928",
  null
  
)

export default component.exports